export const bolepidemiologicos2025Monitoreo = [
  {
    "etiqueta_elemento": "Boletin Semana 1 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 01_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 2 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 02_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 3 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 03_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 4 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 04_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 5 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 05_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 6 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 06_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 7 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 07_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 8 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 08_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 9 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 09_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 10 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 10_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 11 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 11_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 12 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 12_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 13 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 13_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 14 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 14_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 15 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 15_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 16 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 16_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 17 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 17_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 18 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 18_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 19 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 19_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 20 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 20_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 21 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 21_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 22 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 22_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 23 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 23_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 24 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 24_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 25 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 25_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 26 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 26_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 27 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 27_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 28 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 28_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 29 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 29_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 30 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 30_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 31 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 31_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 32 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 32_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 33 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 33_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 34 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 34_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 35 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 35_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 36 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 36_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 37 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 37_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 38 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 38_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 39 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 39_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 40 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 40_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 41 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 41_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 42 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 42_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 43 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 43_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 44 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 44_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 45 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 45_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 46 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 46_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 47 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 47_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 48 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 48_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 49 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 49_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 50 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 50_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 51 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 51_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 52 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 52_2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 53 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Monitoreo/MMC NO 53_2025.pdf",
  },
]